<div class="modal-container">
    <div class="modal-header">
        <h4>{{localize(langSection.ImportUsersErrorModal, langText.ImportErrorHeader)}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
    </div>
    <div class="modal-body">
        <span>{{localize(langSection.ImportUsersErrorModal, langText.ImportErrorBody)}}</span>
    </div>
    <div class="modal-footer justify-content-center">
        <button class="btn btn-green" (click)="dismissModal()">
            {{localize(langSection.Term, langText.Continue)}}
        </button>
    </div>
</div>